import React, { useState, useContext, useEffect } from 'react';
import { TextField, Container, Stack, Button, Paper } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons';

import { DataContext } from '../../../../context/DataContext';
import { simpleMessage } from '../../../../helpers/Helpers';
import { getToken } from '../../../../api/Account';
import { updateFechaQuoteAsync } from '../../../../api/Credits';

const ChangeFechaAbono = ({ setModal, selectedQuote, localReload, setLocalReload }) => {
	const [fecha, setFecha] = useState(new Date());
	const token = getToken();
	const { setIsLoading, setIsUnautorized, access } = useContext(DataContext);

	const changeFecha = async () => {
		setIsLoading(true);

		const data = {
			quoteId: selectedQuote.id,
			fechaPago: moment(fecha).format('YYYY-MM-DD')
		};
		const result = await updateFechaQuoteAsync(token, data);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		setLocalReload(!localReload);
		setModal(false);
	};

	return (
		<div>
			<Container style={{ width: 550 }}>
				<Paper
					style={{
						padding: 20
					}}
				>
					<Stack direction="column" spacing={2} justifyContent="center">
						<DesktopDatePicker
							closeOnSelect
							label="Fecha de Abono Actual"
							inputFormat="DD/MM/YYYY"
							value={moment(selectedQuote.fechaPago).format('YYYY-MM-DD')}
							disabled
							renderInput={(params) => <TextField fullWidth {...params} />}
						/>
						<DesktopDatePicker
							closeOnSelect
							label="Nueva fecha"
							inputFormat="DD/MM/YYYY"
							value={fecha}
							onChange={(newValue) => setFecha(newValue)}
							renderInput={(params) => <TextField fullWidth {...params} />}
						/>

						<Button
							variant="outlined"
							startIcon={
								<FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />
							}
							fullWidth
							onClick={() => changeFecha()}
							style={{
								color: '#00a152',
								borderColor: '#00a152'
							}}
							size="large"
						>
							Cambiar fecha
						</Button>
					</Stack>
				</Paper>
			</Container>
		</div>
	);
};

export default ChangeFechaAbono;
